import React from 'react';
import { RecetasLanding } from './pages/RecetasLanding';
export function App() {
  return <RecetasLanding data-id="element-0" />;
}